import moment from "moment";
import React from "react";
import styled from "styled-components";
import { GlobalInformation } from "../../../global/information";
import { Colors } from "../../../theme/colors";
import { FontSizes } from "../../../theme/fonts";
import Button from "../Button";
import Separator from "../Separator";

interface CheckoutPageItemProps {
  id: string;
  videoPromotionURL: string;
  priceTotal: number;
  discountPercentage: number;
  updatedAt?: number;
  onClick: (checkoutId: string) => void;
}

const CheckoutPageItem = ({
  id,
  videoPromotionURL,
  priceTotal,
  discountPercentage,
  updatedAt,
  onClick,
}: CheckoutPageItemProps) => {
  return (
    <Container>
      <DescriptionContainer>
        <LabelWrapper>
          <LabelKey>Video Promocional</LabelKey>
          <Separator type="small" />
          <LabelValue>{videoPromotionURL}</LabelValue>
        </LabelWrapper>
        <Separator type="medium" />
        <LabelWrapper>
          <LabelKey>Precio ($)</LabelKey>
          <Separator type="small" />
          <LabelValue>{priceTotal}</LabelValue>
        </LabelWrapper>
        <Separator type="medium" />
        <LabelWrapper>
          <LabelKey>Descuento (%)</LabelKey>
          <Separator type="small" />
          <LabelValue>{discountPercentage}</LabelValue>
        </LabelWrapper>
        <Separator type="medium" />
        <LabelWrapper>
          <LabelKey>URL</LabelKey>
          <Separator type="small" />
          <LabelValue>
            {GlobalInformation.hostingURL}/aleman-para-turistas/{id}
          </LabelValue>
        </LabelWrapper>
        <Separator type="medium" />
        <LabelWrapper>
          <LabelKey>Última actualización</LabelKey>
          <LabelValue>{moment(updatedAt).format("LLL")}</LabelValue>
        </LabelWrapper>
      </DescriptionContainer>
      <ActionsContainer>
        <Button
          type="primary-inverted"
          icon="edit"
          onClick={() => {
            onClick(id);
          }}
        />
      </ActionsContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  background-color: ${Colors.White};
  padding: ${8 * 2}px;
  border-radius: 15px;
  border-color: ${Colors.Border};
  border-width: 1px;
  border-style: solid;
`;

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const ActionsContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: center;
  margin-right: ${4 * 4}px;
`;

const LabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
`;

const LabelKey = styled.div`
  font-weight: bold;
  font-size: ${FontSizes.Paragraph};
`;
const LabelValue = styled.div`
  font-size: ${FontSizes.Paragraph};
  word-break: break-word;
`;

export default CheckoutPageItem;
